export const LV_ShipmentAddressStateTR={
ShASID:{en:'ShASID',cs:'ShASID',dataType:'number',format:'#0',required:true},
ShASName:{en:'Country Name',cs:'Název státu',dataType:'string',maxLength:100},
ShASCode:{en:'Country Code',cs:'Kód státu',dataType:'string',maxLength:3}
}